import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GeneralFunctionsService {

  constructor() {
  }

  generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16).toUpperCase();
    });
  }

  mayusAcentos(obj: any): any {
    const excluirCampos = ["password", "usr", "email", "logoBase64", "emailTutor", "emailResponsable"];

    if (Array.isArray(obj)) {
      return obj.map((item) => this.mayusAcentos(item));
    } else if (typeof obj === "object" && obj !== null) {
      const nuevoObjeto: any = {};

      for (const clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (typeof obj[clave] === "string") {

            if (excluirCampos.includes(clave)) {
              nuevoObjeto[clave] = obj[clave];
            } else {

              nuevoObjeto[clave] = obj[clave]
                .replace(/ñ/g, '[[enie-min]]')
                .replace(/Ñ/g, '[[enie-may]]')
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/\[\[enie-min\]\]/g, "ñ")
                .replace(/\[\[enie-may\]\]/g, "Ñ")
                .toUpperCase();
            }

          } else {
            nuevoObjeto[clave] = this.mayusAcentos(obj[clave]);
          }
        }
      }

      return nuevoObjeto;
    }

    return obj;
  }

  formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  generateUUIDv4(): string {
    return crypto.randomUUID();
  }

  // showErrorAlert(message: string, error: HttpErrorResponse): void {
  //   Swal.fire({
  //     icon: 'error',
  //     title: 'Error',
  //     text: message,
  //     footer: error,
  //   }).then();
  // }
  //
  // crudSwal(tipo: 'C' | 'U' | 'D') {
  //   const mensajes = {
  //     C: {
  //       title: '¡CREACION EXITOSA!',
  //       text: 'EL REGISTRO SE CREO CORRECTAMENTE.'
  //     },
  //     U: {
  //       title: '¡ACTUALIZACION COMPLETADA!',
  //       text: 'LOS DATOS FUERON ACTUALIZADOS CORRECTAMENTE.'
  //     },
  //     D: {
  //       title: '¡ELIMINACION EXITOSA!',
  //       text: 'EL REGISTRO FUE ELIMINADO CORRECTAMENTE.'
  //     }
  //   };
  //
  //   const {title, text} = mensajes[tipo];
  //
  //   Swal.fire({
  //     icon: 'success',
  //     title,
  //     text,
  //     confirmButtonText: 'ACEPTAR'
  //   }).then();
  // }

}
